import { FC, memo } from 'react'
import { useFormContext } from '../forms/form'
import FieldError, { useFieldValidity } from './fieldError'

interface RadioButtonInputProps {
    label: string
    value: string
    options: string[]
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    required?: boolean
    name: string
    helperText?: string
}

const RadioButtonInput: FC<RadioButtonInputProps> = ({ 
    label, 
    value, 
    options, 
    onChange, 
    required = false, 
    name,
    helperText
}) => {
    const { disableInputs, isLoading } = useFormContext()
    const { errorMessage, isInvalid, fieldClassName, onBlur, onChange: onValidityChange, onInvalid } = useFieldValidity()

    return (
        <div className="input-holder">
            <label>{label}{required ? '*' : ''}</label>
            <div className="flex flex-col gap-2">
                {options.map((option, index) => (
                    <label key={index} className="flex items-center gap-2 cursor-pointer">
                        <input
                            type="radio"
                            name={name}
                            value={option}
                            checked={value === option}
                            onChange={(e) => {
                                onValidityChange(e)
                                onChange(e)
                            }}
                            onBlur={onBlur}
                            onInvalid={onInvalid}
                            required={required}
                            disabled={disableInputs}
                            className={`${fieldClassName} ${isLoading ? 'animate-pulse' : ''} ${isInvalid ? '!border !border-[#FF4747]' : ''}`}
                        />
                        <span className="text-sm">{option}</span>
                    </label>
                ))}
            </div>
            <FieldError message={errorMessage} />
            {helperText && (
                <div className="text-xs text-gray-500 mt-1">
                    {helperText}
                </div>
            )}
        </div>
    )
}

export default memo(RadioButtonInput)
